import { String, Static, Object, Optional } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';

import { TravelPassApiError } from './error';

export const TravelPassProfileError = TravelPassApiError(UnionEnum(['generic-permission-denied']));
export type TravelPassProfileError = Static<typeof TravelPassProfileError>;

export const TravelPassProfileResponse = Object({
  firstName: String(),
  lastName: String(),
  email: Optional(String()),
  phone: Optional(String()),
  gender: Optional(String()),
  travelpassNumber: String(),
  bonusProgram: Optional(Object({ ebNumber: String(), bonusProgramKey: String(), tier: String() })),
});
export type TravelPassProfileResponse = Static<typeof TravelPassProfileResponse>;
